/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
import{Milliseconds as o}from"../../../core/time.js";const e=.5,r=o(1e3/30);export{e as MAXIMUM_ANIMATION_LOAD,r as MINIMUM_IDLE_ANIMATION_MS};
